import React from "react"
import { useDispatch,useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../../Action";
import { Modal,ModalBody } from "react-bootstrap";
import './RecommendQuestionsModal.css';
import { recommendQuestionData } from "../../../API/api";
import { useNavigate } from "react-router-dom";
import { Home_PAGE_URL } from "../../../Router/routerUrl";
export default function RecommendQuestionsModal() {
	const dispatch = useDispatch();
  const { advanceFilterModalToggle,recommendData } = bindActionCreators(Actions, dispatch);
  const modalState = useSelector((state) => state.domain);
	const recommend = useSelector((state)=>state.recommend);
  const onCloseModal = () => {
    advanceFilterModalToggle({ bool: false, value: "" })
  }
	const navigate = useNavigate()

	const onClickQuestion = (que, queId) => {
		let payload = {
			data: {
				id: queId,
				text: que
			}
		}
		recommendData(payload);
		navigate(`${Home_PAGE_URL}recommend`)
		advanceFilterModalToggle({bool:false,value:""})
	}
	return (
		<>
			<Modal
				show={modalState.modalState}
				onHide={() => onCloseModal()}
				size="lg"
				centered={true}
			>
				<Modal.Header style={{backgroundColor:'white'}} closeButton closeVariant="#344054">
					<span style={{fontSize:'20px',fontWeight:500,color:'#344054'}}>Related Questions</span>
				</Modal.Header>
				<ModalBody className="modalRecentRatingsBody">
					{
						recommend.recommendations && recommend.recommendations.length > 0 && recommend.recommendations.map((obj,ind)=>{
							return(
								<>
								<ul key={ind} style={{paddingLeft:0}}>
									<li className="listItems" onClick={()=>onClickQuestion(obj.questionText,obj.questionUuid)}>{obj.questionText}</li>
								</ul>
								</>
							)
						})
					}
				</ModalBody>
			</Modal>
		</>
	)
}